module.exports = __webpack_public_path__ + "media/images/how-tyre-7b04a12404156578308c8265e26d0131.png";